import { PackPopupType } from '@nf/types/promotion';
import { usePackPopupStates } from '@/features/promotion/cwc-risk-free-bet/hooks/use-pack-popup-states';

import { ImageCouldFromRemoteServer as Image } from '@/components/images';
import { Tooltip } from '@/components/widgets/tooltip';

export const PackPopover = ({ 
	className, 
	message 
}: { 
	className?: string;
	message: string;
}) => {
	const { data: packPopupStates, dataUpdatedAt } = usePackPopupStates([PackPopupType.IncomingVoucher], { shouldCheck: true });
	const isPopoverVisible = packPopupStates?.[0].IsShow;
	
	return isPopoverVisible ? (
		<Tooltip
			key={dataUpdatedAt}
			message={message}
			countdownTime={3000}
			className={className}
			icon={() => (
				<Image
					src="/images/promotion/beginners-pack/giftbox.png"
					alt=""
					width={20}
					height={20}
					isGalaxyFolder={true}
				/>
			)}
		/>
	) : null;
};